import PropTypes from 'prop-types';
import React from 'react';
import { Col, Panel, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { add } from '../../../reducers/workOrder/equipmentTimesheets/equipmentTimesheets.actions';
import { timesheets } from '../../../reducers/workOrder/equipmentTimesheets/equipmentTimesheets.reducer';
import { dirty } from '../../../reducers/workOrder/workOrders.reducer';
import SpinnerButton from '../../SpinnerButton/SpinnerButton';
import ConnectedEquipmentTimesheetForm from './EquipmentTimesheetForm/EquipmentTimesheetForm';
import './EquipmentTimesheets.css';

// eslint-disable-next-line object-curly-newline
export const EquipmentTimesheets = ({ equipmentTimesheets, addEquipmentTimesheet, disabled, workOrderId, saveWorkOrder, workOrderDirty }) => (
  <Panel header="Equipment" >
    {equipmentTimesheets.map(timesheet => (
      <Row key={timesheet.id} >
        <Col xs={12} >
          <ConnectedEquipmentTimesheetForm equipment={timesheet} disabled={disabled} />
        </Col>
      </Row>
    ))}
    <Row>
      { !disabled &&
      <Col xs={6} sm={3} >
        <SpinnerButton onClick={() => addEquipmentTimesheet(workOrderId)} >Add Equipment</SpinnerButton>
      </Col>
      }
      <Col xs={6} sm={2} >
        <SpinnerButton
          onClick={saveWorkOrder}
          bsStyle="primary"
          dirty={workOrderDirty}
          disabled={disabled}
        >
          Save
        </SpinnerButton>
      </Col>
    </Row>
  </Panel>
);

EquipmentTimesheets.propTypes = {
  equipmentTimesheets: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  workOrderDirty: PropTypes.bool.isRequired,
  workOrderId: PropTypes.string.isRequired,
  saveWorkOrder: PropTypes.func.isRequired,
  addEquipmentTimesheet: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export const mapStateToProps = (state, ownProps) => ({
  equipmentTimesheets: timesheets(ownProps.workOrderId, state),
  workOrderDirty: dirty(state, ownProps.workOrderId),
});

export const mapDispatchToProps = dispatch => ({
  addEquipmentTimesheet: id => dispatch(add(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EquipmentTimesheets);



// WEBPACK FOOTER //
// ./src/components/WorkOrder/EquipmentTimesheets/EquipmentTimesheets.jsx